import { fromWeb, str } from "@protomodule/instruments"

export const config = fromWeb({
  REACT_APP_VERSION_INFO: str({ default: "2.39.4" }),
  REACT_APP_GRAPHQL_ENDPOINT: str({ default: "https://smart-collection-api.denovo.cloud" }),
  REACT_APP_GOOGLE_MAPS_API_KEY: str({ default: "AIzaSyAvvF9SPMV1_MsmoWxwlAMp7pK4yTKMeos" }),
})
